import {
  ConversationFilterNames,
  conversationFilterData,
} from "@redotech/effect-api-shared/schema/conversation-filters";
import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-model/views/advanced-filters/date-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { DateTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const LastResponseAtAdvancedFilter: DateTableFilter = {
  type: AdvancedFilterType.DATE,
  Icon: CalendarIcon,
  operators: [
    DateFilterOperator.WITHIN,
    DateFilterOperator.BEFORE,
    DateFilterOperator.AFTER,
  ],
  data: conversationFilterData[ConversationFilterNames.LAST_RESPONSE_AT],
  displayName: "Last response at",
};
